import React from 'react';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import Input from '../common/Formik/Input';
import SelectFormik from '../common/Formik/SelectFormik';

const ReversalForm = (props) => {
  const { t, bindSubmitForm, storeValues, country, bankCodes, docTypes, accountTypes } = props;

  const handleSubmit = (values) => {
    storeValues(values);
  };

  const initialValues = () => {
    return {
      beneficiary: '',
      documentType: '',
      document: '',
      bank: '',
      bankBranch: '',
      accountType: '',
      accountNumber: '',
    };
  };

  const validationSchema = () => {
    return Yup.object().shape({
      beneficiary: Yup.string().required(t('validationRequired')),
      documentType: Yup.string().required(t('validationRequired')),
      document: Yup.string().required(t('validationRequired')),
      bank: Yup.string().required(t('validationRequired')),
      accountNumber: Yup.string().required(t('validationRequired')),
      bankBranch: Yup.string().when('isBranchReq', {
        is: isBranchRequired,
        then: Yup.string().required(t('validationRequired')),
        otherwise: Yup.string(),
      }),
      accountType: Yup.string().when('isAccountTypeReq', {
        is: isAccountTypeRequired,
        then: Yup.string().required(t('validationRequired')),
        otherwise: Yup.string(),
      }),
    });
  };

  const isBranchRequired = () => {
    return ['EC', 'AR', 'BR'].includes(country);
  };

  const isAccountTypeRequired = () => {
    return ['MX', 'CO', 'PE', 'EC', 'AR', 'BR'].includes(country);
  };

  return (
    <Formik initialValues={initialValues()} onSubmit={handleSubmit} validationSchema={validationSchema()}>
      {(formikProps) => {
        bindSubmitForm(formikProps.submitForm);
        return (
          <Form>
            <div className="row">
              <div className="col-6">
                <div className="form-group form-item">
                  <Field label={t('labelBeneficiary')} name="beneficiary" component={Input} required />
                </div>
              </div>
              <div className="col-6">
                <div className="form-group form-item">
                  <Field label={t('labelDocumentType')} name="documentType" component={SelectFormik} options={docTypes} required />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <div className="form-group form-item">
                  <Field label={t('labelDocument')} name="document" component={Input} required />
                </div>
              </div>
              <div className="col-6">
                <div className="form-group form-item">
                  <Field label={t('labelBank')} name="bank" component={SelectFormik} options={bankCodes} required />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <div className="form-group form-item">
                  <Field label={t('labelBankBranch')} name="bankBranch" component={Input} required={isBranchRequired()} />
                </div>
              </div>
              <div className="col-6">
                <div className="form-group form-item">
                  <Field label={t('labelAccountType')} name="accountType" component={SelectFormik} options={accountTypes} required={isAccountTypeRequired()} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <div className="form-group form-item">
                  <Field label={t('labelAccountNumber')} name="accountNumber" component={Input} required />
                </div>
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default ReversalForm;
